(function () {
  'use strict';

  // ----- Drawers (mobile nav, search, filters) -----
  function closeDrawer(drawer) {
    drawer.removeAttribute('open');
    document.body.style.overflow = '';
  }
  function openDrawer(drawer) {
    drawer.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-drawer-close], .nav-drawer__close, .filters__close');
    if (closeBtn) closeBtn.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      var drawer = document.getElementById(id);
      if (drawer) openDrawer(drawer);
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      var host = closer.closest('.nav-drawer, .filters');
      if (host) closeDrawer(host);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.nav-drawer[open], .filters[open]').forEach(closeDrawer);
    }
  });

  // ----- Quantity steppers (product form + cart lines) -----
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    var wrapper = (minus || plus).closest('.quantity-input');
    var input = wrapper && wrapper.querySelector('input[type="number"]');
    if (!input) return;

    var min = parseInt(input.min || '0', 10);
    var value = parseInt(input.value || '1', 10) || 1;
    value = plus ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ----- Cart page: update quantities on change -----
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-qty]')) {
      var form = e.target.closest('form');
      if (form) form.requestSubmit();
    }
  });
})();
